<template>
  <v-list-item @click="clickAction()">
    <v-list-item-title>{{ titleTranslated }}</v-list-item-title>
  </v-list-item>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

@Component
export default class DropdownItem extends Vue {
  @Prop()
  title!: string;

  get titleTranslated() {
      return this.$t(this.title)
  }

  clickAction () {
    this.$emit('clicked')
  }
}
</script>